import { BaseContract } from './baseContract.js';
export class Web3Contract extends BaseContract {
    calculateTransactionFee(_functionName, _paramsOption) {
        throw new Error('Method not implemented.');
    }
    encodedTx(_functionName, _paramsOption) {
        throw new Error('Method not implemented.');
    }
    callViewMethod(_functionName, _paramsOption, _callOptions) {
        throw new Error('Method not implemented.');
    }
    callSendMethod(_functionName, _account, _paramsOption, _sendOptions) {
        throw new Error('Method not implemented.');
    }
}
